<div class="db-website-item" [ngClass]="{'db-ai-demo-website-item': website?.isAiBuilderDemo}">

  <db-website-item-overlay *ngIf="overlay || (!!isUploading && !!disableMigrateButton)" [websiteId]="website?.id"
                           [website]="website"
                           [user]="user"
                           [userSubscription]="userSubscription"
                           [subscriptionType]="userSubscription?.type" [role]="currentWorkspace?.roleId"
                           [isHosted]="!!website?.domain_hash" [isActive]="website?.isActive"
                           [isBooster]="website?.connectedFrom === 'speed_optimizer'"
                           [isIO]="!!website?.managerVersionIO"
                           [isLocalHost]="website?.isLocalhost" [hasCopy]="website?.hasCopy"
                           [isNetwork]="website?.isNetwork" [disableMigrateButton]="disableMigrateButton"
                           [cdnIsEnabled]="cdnIsEnabled"
                           [migrationInProgress]="migrationInProgress"
                           [ongoingMigrationActivity]="ongoingMigrationActivity"
                           [failedMigration]="failedMigration"
                           (onMigrate)="migrateWebsiteDialog()"
                           (onRefresh)="refresh.emit()">
  </db-website-item-overlay>

  <ds-score *ngIf="!website?.isNetwork && !(website?.isAiBuilderDemo && user?.platformClient)" (click)="redirectToAHA()"
            [error]="!desktopScore"
            [hidden]="(desktopScore === 101 && mobileScore === 101) || (!!(ongoingGoogleScoreActivity$ | async) ||
            !!ongoingOptimizingActivities)"
            [loading]="!!(ongoingGoogleScoreActivity$ | async)"
            [dsTooltip]="(ongoingGoogleScoreActivity$ | async) ? ('text_googleSpinnerDesc' | dbText)
      : (!desktopScore ? ('text_googleSpinnerDescError' | dbText) : scoreTooltipRef)"
            [dsTooltipPosition]="!(ongoingGoogleScoreActivity$ | async) && desktopScore ? 'right' : 'bottom'"
            [dsTooltipAlign]="!(ongoingGoogleScoreActivity$ | async) && desktopScore ? 'top' : 'left'"
            [score]="desktopScore" [zIndex]="9" position="absolute" [x]="8" [y]="4"
            dsTooltipMode="hoverStatic"></ds-score>

  <db-website-item-actions *ngIf="website && userSubscription && !(userSubscription.platformPaidClient && website.isAiBuilderDemo)" [website]="website" [user]="user" [userSubscription]="userSubscription"
                           [currentWorkspace]="currentWorkspace" [hostedWebsiteLimit]="hostedWebsiteLimit"
                           [hostedWebsitesIncludedMultiCount]="hostedWebsitesIncludedMultiCount"
                           [disableCopyWebsite]="disableCopyWebsite"
                           (openDemoIframe)="openDemoIframe.emit(previewUrl)"></db-website-item-actions>

  <div class="db-website-item__main-content db-website-item__thumb">
    <img [src]="website?.isNetwork ? '../../../../assets/images/common/multisite_thumbnail.png' : (!website?.isNetwork && (website?.screenshot && !website?.isLocalhost ?
       'data:image/jpg;base64,' + website?.screenshot : (website?.isAiBuilderDemo ? '../../../assets/images/common/no_screenshot-demo.png' : '../../../assets/images/common/no_screenshot.svg')))"/>
    <div class="db-website-item__actions">
      <a class="redirection-layer" (click)="manageWebsite()"></a>
      <div *ngIf="website?.websiteTags && website?.isActive && currentWorkspace?.roleId === clientRoles.OWNER"
           class="db-website-item__tags">
        <p>Tags</p>
        <div>
          <p>
            <span *ngFor="let tag of tagsList; let i = index">
              <span *ngIf="i <= tagsCount - 1 && i <= tagsList.length - 1 ">
              {{ tag }}<span *ngIf="i < tagsCount - 1 && i < tagsList.length - 1">, </span></span>
            </span>
          </p>
          <div>
              <span class="more_tag_titles" *ngIf="tagsList?.length && tagsList?.length > tagsCount"
                    [dsTooltip]="tagsRef" dsTooltipAlign="right">+{{tagsList.length - tagsCount}}
              </span>
            <span (click)="showAddTagDialog(website?.id)"><i class="db-icon db-icon-ds-edit"></i></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="db-website-item__info">

    <div *ngIf="currentWorkspace?.roleId === clientRoles.OWNER && !!website?.domain_hash
         || (!website?.domain_hash && (![userSubscriptionType.FREE, userSubscriptionType.PLATFORM, userSubscriptionType.DEDICATEDVM].includes(userSubscription?.type) || website?.connectedFrom === 'speed_optimizer'))"
         class="db-website-item__checkbox" [ngClass]="{'ds-hide': !website?.isActive || website?.isLocalhost || (website?.isAiBuilderDemo && userSubscription?.platformPaidClient)}">
      <input class="ds-checkbox" [checked]="website.selected" (change)="onCheckboxChange($event)"
             type="checkbox" id="checkbox_{{website?.id}}">
      <label for="checkbox_{{website?.id}}" class="black"></label>
    </div>

    <div class="website-info-wrap" [ngClass]="{'highlight': overlay || (!!isUploading && !!disableMigrateButton)}">
      <div>
        <p class="db-website-item__title mr3" [innerHTML]="website?.title" [dsTooltip]="website?.title"
           dsTooltipColor="black" dsTooltipSize="small" dsTooltipAlign="left"
           [dsTooltipVisible]="website?.title?.length > 12"></p>
        <i class="db-icon db-icon-ds-ai ml8" *ngIf="userSubscription?.multipleBuilder && website?.builderType === 'wvc'" dsTooltip="{{'text_builtWithAIVibe' | dbText}}"
           dsTooltipPosition="top" dsTooltipColor="black" dsTooltipSize="small" dsTooltipAlign="left"></i>
        <i class="db-icon db-icon-ds-sidebar-builder ml8" *ngIf="userSubscription?.multipleBuilder && website?.builderType === 'section_based'"   dsTooltip="{{'text_builtWithAIClassicBuilder' | dbText}}"
           dsTooltipPosition="top" dsTooltipColor="black" dsTooltipSize="small" dsTooltipAlign="left"></i>
        <div class="db-website-item-subsites__dropdown"
             *ngIf="website?.isNetwork && !overlay && !(!!isUploading && !!disableMigrateButton)">
          <span class="db-divider"></span>
          <i class="db-icon db-icon-ds-arrow-small" (click)="toggleSubSites()"
             [ngClass]="{'toggled': subSitesList?.nativeElement?.style?.display !== 'none'}"></i>
        </div>

        <db-websites-list *ngIf="website?.isNetwork && website?.isActive" #subSitesList
                          [style.display]="'none'" (onClose)="toggleSubSites(true)"
                          title="Sites in this multisite network"
                          [websites]="networkSubSitesOptions$ | async"></db-websites-list>
      </div>
      @if(demoUser){
      <a class="db-website-item__site-url db-link-blue" [innerHTML]="displayWebsiteUrl"
        (click)="openDemoIframe.emit()"
        [dsTooltip]="displayWebsiteUrl" dsTooltipColor="black" dsTooltipSize="small" dsTooltipAlign="left"
        [dsTooltipVisible]="displayWebsiteUrl.length > 16"></a>
      }@else{
      <a class="db-website-item__site-url db-link-blue" [innerHTML]="displayWebsiteUrl"
        [href]="previewUrl" target="_blank" rel="noopener"
        [dsTooltip]="displayWebsiteUrl" dsTooltipColor="black" dsTooltipSize="small" dsTooltipAlign="left"
        [dsTooltipVisible]="displayWebsiteUrl.length > 16"></a>
      }

    </div>
    <a *ngIf="!!website?.domain_hash
          || (!website?.domain_hash
          && (![userSubscriptionType.FREE, userSubscriptionType.PLATFORM, userSubscriptionType.DEDICATEDVM].includes(userSubscription?.type)
          || website?.connectedFrom === 'speed_optimizer')
          )"
       class="ds-btn-black ds-btn-small"
       [ngClass]="{
         'ds-btn-disabled': !website?.isActive || pluginUpdating
         || (disableMigrateButton && !website?.domain_hash && (user.platformClient || userSubscription.trialClient))}"
       (click)="manageWebsite()">
      <span *ngIf="!pluginUpdating" [innerHTML]="'text_manageButton' | dbText"></span>
      <db-loading-circular-spinner *ngIf="pluginUpdating"></db-loading-circular-spinner>
    </a>
  </div>

</div>

<div *ngIf="website?.isNetwork" class="db-website-item-multisite-layers"
     [ngClass]="{'inactive': overlay || (!!isUploading && !!disableMigrateButton)}">
  <div class="first"></div>
  <div class="second"></div>
</div>

<ng-template #TooltipLabelRef>
  <p class="ds-tooltip-title" [innerHTML]="'text_addWebsiteHostingTenWeb' | dbText"></p>
  <p *ngIf="website?.type === 'staging'" [innerHTML]="'text_siteStagingAccessDescription' | dbText"></p>
</ng-template>

<ng-template #scoreTooltipRef>
  <db-score-info-tooltip-hover
    [showLearnMore]="(!!website?.domain_hash || user?.oneProductOrBundleClient) && !migrationInProgress"
    [websiteScore]="website?.score" [websiteId]="website?.id" [demoUser]="demoUser"
  ></db-score-info-tooltip-hover>
</ng-template>

<ng-template #tagsRef>
  <div class="db-website-item__tag-list">
    <p [innerHTML]="tagsList?.length + ' Tags assigned'"></p>
    <ul>
      <li *ngFor="let tag of website?.tagsDefaultList | keyvalue">
        <span [innerHTML]="tag.value"></span>
      </li>
    </ul>
  </div>

</ng-template>
